import { IElement } from 'routes/private/Editor/types';

export const editNameResolver = (element: IElement, name: string ):IElement => {
  element.name = name;
  return element;
}
